import {
  OrderStatus,
  ProductCode,
  WalletConsumeSource,
  WalletRechargeType,
  WalletRecordType,
} from "~/common/constants"

// 面向用户的订单 / 积点文案，PC 与移动端共用；Staff 内部文案见 pages/Staff/labels.ts

export const POINT_RECORD_TYPE_OPTIONS = [
  { label: "收入", value: WalletRecordType.income },
  { label: "支出", value: WalletRecordType.expense },
  { label: "到期", value: WalletRecordType.expiredClear },
] as const

export const WALLET_RECHARGE_TYPE_LABEL: Record<WalletRechargeType, string> = {
  [WalletRechargeType.registrationGift]: "首登赠送积点",
  [WalletRechargeType.staff]: "手动赠送",
  [WalletRechargeType.levelInclude]: "专业版月度积点包",
  [WalletRechargeType.walletPackage]: "单独充值积点",
}

const WALLET_CONSUME_SOURCE_LABEL: Record<WalletConsumeSource, string> = {
  [WalletConsumeSource.parseVideo]: "视频拆解消耗",
  [WalletConsumeSource.generateVideo]: "视频生成消耗",
  [WalletConsumeSource.whiteBgImage]: "白底图生成消耗",
  [WalletConsumeSource.nineGridImage]: "九宫格图生成消耗",
}

export const getPointRecordDescription = (
  record: API.User.WalletRecordItem,
): string => {
  if (record.remark) return record.remark

  if (
    record.record_type === WalletRecordType.income &&
    record.wallet_recharge_type
  ) {
    return WALLET_RECHARGE_TYPE_LABEL[record.wallet_recharge_type]
  }

  if (
    record.record_type === WalletRecordType.expense &&
    record.wallet_consume_source
  ) {
    return WALLET_CONSUME_SOURCE_LABEL[record.wallet_consume_source]
  }

  return record.record_type === WalletRecordType.expiredClear
    ? "到期清零"
    : "积点变动"
}

export const ORDER_STATUS_LABEL: Record<OrderStatus, string> = {
  [OrderStatus.init]: "待创建支付",
  [OrderStatus.waitPay]: "待支付",
  [OrderStatus.cancelled]: "已取消",
  [OrderStatus.closed]: "已关闭",
  [OrderStatus.succeeded]: "交易成功",
}

const PRODUCT_NAME: Record<ProductCode, string> = {
  [ProductCode.proMonthlyV1]: "专业版月度套餐",
  [ProductCode.proMonthlyGiftV1]: "专业版赠送套餐",
  [ProductCode.walletProV1]: "专业版积点包",
  [ProductCode.walletFreeV1]: "积点包",
  [ProductCode.bulkWalletV1]: "大客户积点",
}

export const getOrderProductName = (order: API.User.UserOrder): string => {
  if (!order.description && order.bulk_wallet_package) {
    return `大客户积点（${order.bulk_wallet_package.wallet_recharge_amount} 积点）`
  }
  return (
    order.description ||
    (order.product_code ? PRODUCT_NAME[order.product_code] : undefined) ||
    "订单商品"
  )
}

export const getOrderWalletAmount = (
  order: API.User.UserOrder,
): number | undefined =>
  order.bulk_wallet_package?.wallet_recharge_amount ??
  order.wallet_package?.wallet_recharge_amount
